import { ParsedDate } from '../parsed/parsedDate';
import { z } from 'zod';

export const AdReactionType = z.enum(['seen', 'seenDetails', 'closed', 'swipedAway', 'timeout', 'error']);
export type AdReactionType = z.infer<typeof AdReactionType>;

/**
 * Per-product reaction to an advertisement, keyed by itemId in {@link AdReaction.linkedProducts}.
 * A timing is `null` when the action never happened.
 */
export const AdReactionProduct = z.object({
    addedAfterMs: z.number().nullable(),
    navigatedAfterMs: z.number().nullable(),
});
export type AdReactionProduct = z.infer<typeof AdReactionProduct>;

export const AdReaction = z.object({
    reactionGuid: z.string(),
    advertisementGuid: z.string(),
    seenOn: ParsedDate,
    reaction: AdReactionType,
    interacted: z.boolean(),
    durationSeen: z.number(),
    iterations: z.number(),
    /** How far the display got in whole percent, rounded down: the furthest point reached; 0 if never on screen. */
    seenPercentage: z.number().int().min(0).max(100).optional(),
    swiped: z.boolean().optional(),
    enlarged: z.boolean().optional(),
    closed: z.boolean().optional(),
    linkedProducts: z.record(z.string(), AdReactionProduct).optional(),
});
export type AdReaction = z.infer<typeof AdReaction>;
